import { render, staticRenderFns } from "./LeaveWord.vue?vue&type=template&id=6ebd8ca2&scoped=true"
import script from "./LeaveWord.vue?vue&type=script&lang=js"
export * from "./LeaveWord.vue?vue&type=script&lang=js"
import style0 from "./LeaveWord.vue?vue&type=style&index=0&id=6ebd8ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebd8ca2",
  null
  
)

export default component.exports